import { Popup, TabPanel } from "devextreme-react";
import { Item } from "devextreme-react/tab-panel";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../utils/hasPermission";
import { PERM } from "../../../utils/permissions";
import EmployeeList from "./EmployeeList";
import ReviewerList from "./ReviewerList";
import EmployeeTileView from "./EmployeeTileView";
import BasicInformation from "../../PersonalRecord/BasicInformation";
import { employeeTabItems } from "./data";
import ProjectList from "./ProjectList";

export default function EmployeeTabWrapper(props) {
  const {
    // setCurrentEmployee,
    employeeDataGridRef,
    // setEmployeeInfoPopupVisible,
    // employeeTileViewRef,
  } = props;

  const userInfo = useSelector((state) => state.userInfo);
  const canEditReviewer = hasPermission(userInfo.permissions, PERM.ORG_REVIEWER_EDIT);

  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [employeeInfoPopupVisible, setEmployeeInfoPopupVisible] =
    useState(false);

  const employeeInfoPopupRef = useRef(null);

  const onSelectionChanged = (e) => {
    if (e.addedItems[0].title == "REVIEWER LIST") {
      setCurrentEmployee(null);
    }
  };

  const onHiding = (e) => {
    setEmployeeInfoPopupVisible(false);
  };

  const onShowing = (e) => {
    employeeInfoPopupRef.current.instance.repaint();
  };

  const itemTitleRender = (item) => {
    return <span>{item.name}</span>;
  };

  const itemRender = () => {
    return <ProjectList currentEmployee={currentEmployee} />;
  };

  return (
    <React.Fragment>
      <TabPanel
        id="tabPanel"
        deferRendering={false}
        // height={500}
        onSelectionChanged={onSelectionChanged}
      >
        <Item title={"EMPLOYEE LIST"}>
          <EmployeeList
            employeeDataGridRef={employeeDataGridRef}
            setCurrentEmployee={setCurrentEmployee}
            setEmployeeInfoPopupVisible={setEmployeeInfoPopupVisible}
          />
        </Item>
        {canEditReviewer && (
          <Item title={"REVIEWER LIST"}>
            <ReviewerList />
          </Item>
        )}
      </TabPanel>
      {/* <EmployeeTileView
        employeeTileViewRef={employeeTileViewRef}
        employeeDataGridRef={employeeDataGridRef}
        setCurrentEmployee={setCurrentEmployee}
        setEmployeeInfoPopupVisible={setEmployeeInfoPopupVisible}
        employeeInfoPopupVisible={employeeInfoPopupVisible}
      /> */}
      {currentEmployee && (
        <Popup
          id="employeeInfoPopup"
          ref={employeeInfoPopupRef}
          visible={employeeInfoPopupVisible}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          title="PERSONAL RECORD"
          width={1500}
          height={"auto"}
          onHiding={onHiding}
          onShowing={onShowing}
        >
          <BasicInformation userInfo={currentEmployee} />
          <div className="sections">
            <TabPanel
              id="tpEmployee"
              height={"100%"}
              // height={800}
              dataSource={employeeTabItems}
              selectedIndex={0}
              loop={false}
              itemTitleRender={itemTitleRender}
              itemRender={itemRender}
            />
          </div>
        </Popup>
      )}
    </React.Fragment>
  );
}
